import { Pipe, PipeTransform } from '@angular/core';

import { statusProjetados, isStatusProjetadoEmNegociacao } from '../cliente-analise-mercado-status-projetado';

@Pipe({
    name: 'clienteAnaliseMercadoStatusProjetado'
})
export class ClienteAnaliseMercadoStatusProjetadoPipe implements PipeTransform {
    transform(value: number, idEtapaNegociacaoProjecao: number = null, nomeEtapaNegociacaoProjecao: string = null): string {
        if (!value) {
            return '';
        }

        const index = statusProjetados.findIndex(status => status.id === value);
        if (index > -1) {
            // Em Negociação com etapa de negociação
            if (isStatusProjetadoEmNegociacao(statusProjetados[index].id) && idEtapaNegociacaoProjecao && nomeEtapaNegociacaoProjecao) {
                return nomeEtapaNegociacaoProjecao;
            }

            return statusProjetados[index].nome;
        }
        return '';
    }
}
